import { render, staticRenderFns } from "./postCourseDetail.vue?vue&type=template&id=6c421092&scoped=true"
import script from "./postCourseDetail.vue?vue&type=script&lang=js"
export * from "./postCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./postCourseDetail.vue?vue&type=style&index=0&id=6c421092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c421092",
  null
  
)

export default component.exports